import { FieldVariant, DynamicField, SelectFieldProps, SelectOption, DynamicForm } from '@/components/form-builder/form-builder.types';
import { BehaviorSubject } from 'rxjs';
import { MeetingService } from '../../meeting.service';

interface IGetMeetingHistoryFiltersFormObjectProps {
  dossierTypeSelected: BehaviorSubject<SelectOption | undefined>;
  dossierSelected: BehaviorSubject<SelectOption | undefined>;
  selectedCom: BehaviorSubject<SelectOption | undefined>;
  meetingService: MeetingService;
}

export const getMeetingHistoryFiltersFormObject = ({
  dossierTypeSelected,
  dossierSelected,
  selectedCom,
  meetingService,
}: IGetMeetingHistoryFiltersFormObjectProps): DynamicForm => {
  const dossiersOptions: BehaviorSubject<SelectOption[]> = new BehaviorSubject<SelectOption[]>([]);
  const committeeOptions: BehaviorSubject<SelectOption[]> = new BehaviorSubject<SelectOption[]>([]);
  const committeeFieldRerender = new BehaviorSubject<boolean>(true);

  const selectedTypeField: DynamicField<SelectFieldProps> = {
    label: 'meeting.history.filters.type.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    class: 'max-w-[250px]',
    props: {
      placeholder: 'meeting.history.filters.type.placeholder',
      value: dossierTypeSelected,
      onSelectChange(value: SelectOption) {
        dossierSelected.next(undefined);
        committeeFieldRerender.next(true);
        dossierTypeSelected.next(value);
        meetingService.getDossiers(value.code as 'ppm' | 'dac').subscribe({
          next: dossiers => {
            dossiersOptions.value.length = 0;
            dossiersOptions.next(
              dossiers.map((dossier: any) => {
                return { name: dossier.ref, code: dossier.id };
              })
            );
          },
        });
      },
      options: [
        { name: 'Ppm', code: 'ppm' },
        { name: 'Dac', code: 'dac' },
      ],
    },
  };

  const selectDossierField: DynamicField<SelectFieldProps> = {
    label: 'meeting.history.filters.dossier.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    class: 'max-w-[250px]',
    props: {
      placeholder: 'meeting.history.filters.dossier.placeholder',
      value: dossierSelected,
      options: dossiersOptions,
      filterEnabled: true,
      onSelectChange(event: SelectOption) {
        selectedCom.next(undefined);
        committeeFieldRerender.next(true);
        dossierSelected.next(event);
        meetingService.getCommitteesByDossierId(event.code as number, dossierTypeSelected.value?.code as 'ppm' | 'dac').subscribe({
          next: coms => {
            committeeOptions.value.length = 0;
            committeeOptions.next(
              coms.map((com: any) => {
                return { name: com.nom, code: com.id };
              })
            );

            if (committeeOptions.value.length > 0) {
              committeeFieldRerender.next(false);
            }
          },
        });
      },
    },
  };

  const selectCommiitteeField: DynamicField<SelectFieldProps> = {
    label: 'meeting.history.filters.committee.label',
    variant: FieldVariant.SELECT,
    isRequired: true,
    isDisabled: committeeFieldRerender,
    class: 'max-w-[250px]',
    props: {
      placeholder: 'meeting.history.filters.committee.placeholder',
      value: selectedCom,
      options: committeeOptions,
      filterEnabled: true,
      onSelectChange(event: SelectOption) {
        selectedCom.next(event);
      },
    },
  };

  return {
    title: '',
    isHeaderHidden: true,
    grids: [
      {
        title: '',
        isHeaderHidden: true,
        gridItems: [
          {
            fields: [selectedTypeField, selectDossierField, selectCommiitteeField],
          },
        ],
      },
    ],
  };
};
